import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

require('./assets/spectre.min.css')
require('./assets/spectre-icons.min.css')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  data: {
    validated: false,
    admin: false,
    showSidebar: screen.width > 599,
    user: null,
    pageTitle: '',
    client: {
      matters: [],
      answers: {},
      matter: null,
      ready: false
    }
  },
  created: function () {
    // VALIDATION AND LOGIN
    axios.get('/api/users/validated').then(res => {
      if (res.status === 200) {
        this.validated = true
        this.user = res.data
        this.admin = parseInt(this.user.level) < 5
        if (!this.admin) {
          this.getClientMatters()
        }
      }
    }).catch(e => { return })

    // Hide the sidebar after navigation on mobile
    router.afterEach((to, from) => {
      if (screen.width < 600) {
        this.showSidebar = false
      }
    })
  },
  methods: {
    getClientMatters () {
      axios.get('/api/matters/clientmatters').then(res => {
        if (res.status === 200) {
          if (res.data) {
            this.client.matters = res.data
            this.setupAnswers()
          }
        }
      }).catch(e => { return })
    },

    setupAnswers () {
      // Collect the answers from each matter into the global answers object,
      // making a map of answer refs to sorted answers
      let answers = this.client.answers
      this.client.matters.forEach(m => {
        if (!m.answers || !m.answers.length) return
        m.answers.forEach(a => {
          if (answers[a.ref]) {
            answers[a.ref].push(a)
          } else {
            answers[a.ref] = [a]
          }
        })
      })
      this.client.ready = true
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js